import Phaser from "phaser";
import { SceneKey } from "./scene-keys";

/** First scene: one-time setup, then hands over to the preloader. */
export class BootScene extends Phaser.Scene {
	constructor() {
		super(SceneKey.Boot);
	}

	create(): void {
		setAppState("loading");
		this.scene.start(SceneKey.Preload);
	}
}

/** Coarse app state on <body data-app-state> (loading | ready | error), used by e2e tests. */
export function setAppState(state: "loading" | "ready" | "error"): void {
	document.body.dataset.appState = state;
}
